(() => {
  if (customElements.get('iy-variant-specifications')) return;

  class VariantSpecifications extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.getAttribute('form-id'));
      if (!this.form || this.syncVariant) return;
      this.panels = Array.from(this.querySelectorAll('[data-variant-specification]'));
      this.fallback = this.querySelector('[data-variant-specification-fallback]');
      this.empty = this.querySelector('[data-variant-specification-empty]');
      this.status = this.querySelector('[data-variant-specification-status]');
      this.currentVariant = null;
      this.syncVariant = () => this.showVariant(this.form.elements.namedItem('id')?.value);
      this.onChange = (event) => {
        if (event.target.name === 'id') this.syncVariant();
      };
      this.form.addEventListener('variant:changed', this.syncVariant);
      this.form.addEventListener('change', this.onChange);
      window.addEventListener('pageshow', this.syncVariant);
      this.syncVariant();
    }

    disconnectedCallback() {
      if (!this.syncVariant) return;
      this.form.removeEventListener('variant:changed', this.syncVariant);
      this.form.removeEventListener('change', this.onChange);
      window.removeEventListener('pageshow', this.syncVariant);
      this.syncVariant = null;
    }

    showVariant(value) {
      const id = String(value || '');
      const selected = this.panels.find((panel) => panel.dataset.variantSpecification === id);
      this.panels.forEach((panel) => { panel.hidden = panel !== selected; });
      if (this.fallback) this.fallback.hidden = !id || Boolean(selected);
      this.empty.hidden = Boolean(id && (selected || this.fallback));
      if (this.currentVariant !== null && this.currentVariant !== id) {
        this.status.textContent = selected
          ? `Specifications updated for ${selected.dataset.variantTitle}.`
          : (id && this.fallback ? 'General product specifications shown.' : this.empty.textContent);
      }
      this.currentVariant = id;
    }
  }

  customElements.define('iy-variant-specifications', VariantSpecifications);
})();
